<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ `Work Order - ${work_order.id}-${work_order.public_id}` }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-tooltip>
                                <template slot="activator">
                                    <v-btn icon @mouseup.left="printPDF"><v-icon>print</v-icon></v-btn>
                                </template>
                                {{ $t("lang.print") }}
                            </bc-tooltip>
                            <bc-btn-refresh @invoke-method="dbGetWorkOrder(true)"></bc-btn-refresh>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-container grid-list-xl v-if="work_order != null">
                    <v-layout row :wrap="$bp.smallScreen">
                        <v-flex xs12 md6 lg3 align-self-start pb-0 :pl-0="!$bp.smallScreen">
                            <v-layout row wrap>
                                <v-flex xs8 py-0>
                                    <bc-tooltip perm="companies.update">
                                        <template slot="activator">
                                            <v-chip
                                                v-if="work_order.status"
                                                small
                                                class="clickable mr-auto"
                                                :color="work_order.status.chip_color"
                                                @click="update_work_order_status_dialog = true"
                                                text-color="white"
                                            >
                                                <span>{{ work_order.status.status }}</span>
                                            </v-chip>
                                        </template>
                                        {{ $t("lang.edit_work_order_status") }}
                                    </bc-tooltip>
                                </v-flex>
                                <v-flex xs4 pr-0 py-0>
                                    <div class="ml-auto">
                                        <bc-tooltip perm="companies.update">
                                            <template slot="activator">
                                                <v-btn @mouseup.left="openCompanyModal()" icon>
                                                    <v-icon color="indigo">edit</v-icon>
                                                </v-btn>
                                            </template>
                                            {{ $t("lang.edit_work_order") }}
                                        </bc-tooltip>
                                    </div>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex py-1>
                                    <p class="display-1 mb-0 text-xs-center">Device # {{ work_order.public_id }}</p>
                                    <p class="display-0 mb-0 text-xs-center">{{ work_order.company }}</p>
                                    <small class="mb-0 text-xs-center">{{ "Requested: " + work_order.request_date }}</small>
                                </v-flex>
                            </v-layout>
                            <v-divider class="my-0"></v-divider>
                            <bc-list prepend-icon="dock" perm="work_order.change" prepend-position="top" icon-color="primary">
                                <template>
                                    <v-container pa-2>
                                        <v-layout row wrap>
                                            <v-flex xs6 mt-1>{{ `${$t("lang.device_received")}:` }}</v-flex>
                                            <v-flex xs6 fw-bold mt-1>{{ work_order.date_received != null ? "Yes" : "No" }} </v-flex>

                                            <v-flex xs6 mt-1>{{ `${$t("lang.received")}:` }}</v-flex>
                                            <v-flex xs6 fw-bold mt-1>{{ work_order.date_received != null ? work_order.date_received : "---" }}</v-flex>
                                            <v-flex xs12 mt-1
                                                ><v-btn
                                                    v-if="work_order.date_received == null"
                                                    style="width: 100%"
                                                    small
                                                    color="primary"
                                                    @click="receive_dialog = true"
                                                    >Receive Device</v-btn
                                                ></v-flex
                                            >
                                        </v-layout>
                                    </v-container>
                                </template>
                            </bc-list>
                            <v-divider class="my-0"></v-divider>
                            <bc-list prepend-icon="chat_bubble" prepend-position="top" perm="work_order.change" icon-color="primary">
                                <template>
                                    <bc-tooltip right>
                                        <template slot="activator">
                                            <v-container pa-2>
                                                <v-layout row wrap>
                                                    <v-flex xs12>
                                                        <span>{{ work_order.reason_for_return }}</span>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </template>
                                        {{ $t("lang.reason_for_return") }}
                                    </bc-tooltip>
                                </template>
                            </bc-list>
                            <v-divider class="my-0"></v-divider>
                            <bc-list prepend-icon="person" prepend-position="top" perm="work_order.change" icon-color="primary">
                                <template>
                                    <v-container pa-2>
                                        <v-layout row wrap>
                                            <v-flex xs6 mt-1>{{ `${$t("lang.contact")}:` }}</v-flex>
                                            <v-flex xs6 fw-bold mt-1>{{ work_order.contact_name }}</v-flex>

                                            <v-flex xs6 mt-1>{{ `${$t("lang.phone_number")}:` }}</v-flex>
                                            <v-flex xs6 fw-bold mt-1>{{ work_order.contact_phone_formatted }}</v-flex>

                                            <v-flex xs6 mt-1>{{ `${$t("lang.email")}:` }}</v-flex>
                                            <v-flex xs6 fw-bold mt-1
                                                ><span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{
                                                    work_order.contact_email
                                                }}</span></v-flex
                                            >
                                        </v-layout>
                                    </v-container>
                                </template>
                            </bc-list>
                            <v-divider class="my-0"></v-divider>
                            <bc-list prepend-icon="person" prepend-position="top" perm="work_order.change" icon-color="primary">
                                <template>
                                    <v-container pa-2>
                                        <v-layout row wrap>
                                            <v-flex xs6 mt-1>{{ `${$t("lang.created_by")}:` }}</v-flex>
                                            <v-flex xs6 fw-bold mt-1>{{ work_order.created_by }}</v-flex>

                                            <v-flex xs6 mt-1>{{ `${$t("lang.created")}:` }}</v-flex>
                                            <v-flex xs6 fw-bold mt-1>{{ work_order.date_created }}</v-flex>
                                        </v-layout>
                                    </v-container>
                                </template>
                            </bc-list>
                            <v-divider class="my-0"></v-divider>
                        </v-flex>
                        <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
                        <v-flex xs12 md6 lg9 :pr-0="!$bp.smallScreen" :pl-4="!$bp.smallScreen" align-self-start>
                            <v-layout row wrap>
                                <v-flex xs12 md6>
                                    <v-container pa-3>
                                        <v-layout row wrap>
                                            <v-toolbar color="grey lighten-3" elevation="0" class="shadow-none">
                                                <v-toolbar-title class="ml-0">Zoho Quote</v-toolbar-title>
                                                <v-spacer></v-spacer>
                                                <bc-tooltip perm="companies.update">
                                                    <template slot="activator">
                                                        <v-btn @mouseup.left="requote()" icon>
                                                            <v-icon color="black">edit</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    {{ $t("lang.edit_zoho_quote") }}
                                                </bc-tooltip>
                                            </v-toolbar>
                                            <v-flex xs4>{{ `${$t("lang.customer")}:` }}</v-flex>
                                            <v-flex xs8>{{ work_order.zoho_customer_name ? work_order.zoho_customer_name : "---" }}</v-flex>
                                            <v-flex xs4>{{ `${$t("lang.estimate_number_short")}:` }}</v-flex>
                                            <v-flex xs8>{{ work_order.zoho_estimate_number ? work_order.zoho_estimate_number : "---" }}</v-flex>
                                            <v-flex xs4>{{ `${$t("lang.total")}:` }}</v-flex>
                                            <v-flex xs8>{{ work_order.zoho_total ? work_order.zoho_total : "---" }}</v-flex>
                                            <v-flex xs4>{{ `${$t("lang.status")}:` }}</v-flex>
                                            <v-flex xs8>{{ work_order.zoho_status ? work_order.zoho_status : "---" }}</v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <v-container pa-3>
                                        <v-form ref="workPerformedForm">
                                            <v-layout row wrap>
                                                <v-toolbar color="grey lighten-3" elevation="0" class="shadow-none">
                                                    <v-toolbar-title class="ml-0">Work Performed</v-toolbar-title>
                                                </v-toolbar>
                                                <v-flex xs12 pt-0 pl-0 pr-0>
                                                    <v-textarea
                                                        v-model="work_order.work_performed"
                                                        label="What Work was Performed?"
                                                        single-line
                                                        auto-grow
                                                        rows="5"
                                                        validate-on-blur
                                                        hide-details
                                                        @input="work_order.work_performed = $event ? $event : null"
                                                    ></v-textarea>
                                                </v-flex>
                                                <v-flex xs6 pa-0>{{ `${$t("lang.performed_by")}:` }}</v-flex>
                                                <v-flex xs6 pa-0
                                                    ><bc-autocomplete
                                                        v-model="work_order.performed_by"
                                                        :label="$t('lang.none')"
                                                        single-line
                                                        clearable
                                                        class="py-0 mt-0 no-text-field-details"
                                                        :items="people"
                                                        item-value="people_id"
                                                        item-text="combined_name"
                                                        :rules="ifValid('work_orders.performed_by')"
                                                    ></bc-autocomplete
                                                ></v-flex>
                                                <v-flex xs6 pa-0>{{ `${$t("lang.date_completed")}:` }}</v-flex>
                                                <v-flex xs6 pa-0
                                                    ><bc-date-picker
                                                        v-model="work_order.date_performed"
                                                        :label="$t('lang.not_done')"
                                                        single-line
                                                        clearable
                                                        no-title
                                                        inputClass=" no-text-field-details"
                                                        :rules="ifValid('work_orders.date_performed')"
                                                        @update="work_order.date_performed = $event"
                                                    ></bc-date-picker
                                                ></v-flex>
                                                <v-flex xs6 pa-0>{{ `${$t("lang.outbound_shipping_carrier")}:` }}</v-flex>
                                                <v-flex xs6 pa-0
                                                    ><bc-autocomplete
                                                        v-model="work_order.outbound_carrier_id"
                                                        :label="$t('lang.none')"
                                                        single-line
                                                        clearable
                                                        class="py-0 mt-0 no-text-field-details"
                                                        :items="shipping_carriers"
                                                        item-value="company_id"
                                                        item-text="company"
                                                        :rules="ifValid('work_orders.outbound_carrier_id')"
                                                    ></bc-autocomplete
                                                ></v-flex>
                                                <v-flex xs6 pa-0>{{ `${$t("lang.outbound_tracking_number")}:` }}</v-flex>
                                                <v-flex xs6 pa-0
                                                    ><v-text-field
                                                        v-model="work_order.outbound_tracking_number"
                                                        :label="$t('lang.outbound_tracking_number')"
                                                        placeholder="#"
                                                        single-line
                                                        class="py-0 mt-0 no-text-field-details append-outer-ma-0"
                                                        :counter="showCounter(work_order.outbound_tracking_number, 'work_order.outbound_tracking_number')"
                                                        :rules="ifValid('work_orders.outbound_tracking_number')"
                                                        @change="
                                                            work_order.outbound_tracking_number != work_order.outbound_tracking_number
                                                                ? getShipping(work_order.outbound_tracking_number, 'outbound_loading')
                                                                : null
                                                        "
                                                    >
                                                        <template slot="append-outer">
                                                            <bc-tooltip>
                                                                <template slot="activator">
                                                                    <v-btn
                                                                        v-if="
                                                                            work_order.outbound_carrier_id != null &&
                                                                            work_order.outbound_tracking_number != null &&
                                                                            work_order.outbound_tracking_url
                                                                        "
                                                                        @click="trackParcel"
                                                                        icon
                                                                    >
                                                                        <v-icon>local_shipping</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                {{ $t("lang.track_parcel") }}
                                                            </bc-tooltip>
                                                        </template>
                                                    </v-text-field></v-flex
                                                >
                                            </v-layout>
                                        </v-form>
                                    </v-container>
                                </v-flex>
                            </v-layout>
                            <v-divider class="my-0"></v-divider>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @mouseup.left="$router.push({ name: 'work_orders' })" flat>{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @click="updateWorkPerformed">{{ $t("lang.save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-container>
        <bc-dialog :value="requote_dialog" max-width="700">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.attach_estimate") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="requote_dialog"
                        :dialog-status="requote_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text class="pb-5">
                    <v-form ref="quoteForm">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12 pb-0 pt-2>
                                    {{ $t("lang.company") }}
                                </v-flex>
                                <v-flex xs12 pt-0 pb-2 fw-semi-bold fs-18>
                                    {{
                                        selectedEstimate
                                            ? selectedEstimate.zoho_customer_name
                                            : work_order.zoho_customer_name
                                            ? work_order.zoho_customer_name
                                            : "---"
                                    }}
                                </v-flex>
                                <v-flex xs12 pb-0 pt-2>
                                    {{ $t("lang.zoho_estimate_number_short") }}
                                </v-flex>
                                <v-flex xs12 pt-0 pb-2 fw-semi-bold fs-18>
                                    {{
                                        selectedEstimate
                                            ? selectedEstimate.zoho_estimate_number
                                            : work_order.zoho_estimate_number
                                            ? work_order.zoho_estimate_number
                                            : "---"
                                    }}
                                </v-flex>
                                <v-flex xs12 pb-0 pt-2>
                                    {{ $t("lang.zoho_total") }}
                                </v-flex>
                                <v-flex xs12 pt-0 pb-2 fw-semi-bold fs-18>
                                    {{ selectedEstimate ? selectedEstimate.zoho_total : work_order.zoho_total ? work_order.zoho_total : "---" }}
                                </v-flex>
                                <v-flex xs12 pb-0 pt-2>
                                    {{ $t("lang.zoho_status") }}
                                </v-flex>
                                <v-flex xs12 pt-0 pb-2 fw-semi-bold fs-18>
                                    {{ selectedEstimate ? selectedEstimate.zoho_status : work_order.zoho_status ? work_order.zoho_status : "---" }}
                                </v-flex>
                                <v-flex xs12>
                                    <bc-autocomplete
                                        v-model="requote_estimate.zoho_estimate_id"
                                        :label="`${$t('lang.zoho_estimate_id')} *`"
                                        :items="estimatesAdjusted"
                                        item-value="estimate_id"
                                        item-text="zoho_estimate_number"
                                        hide-selected
                                        :rules="ifValid('work_orders.zoho_estimate_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="requote_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="updateQuote()">{{ $t("lang.attach") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <bc-dialog :value="update_work_order_status_dialog" max-width="300">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.update_status") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="update_work_order_status_dialog"
                        :dialog-status="update_work_order_status_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text class="pb-5">
                    <v-form ref="quoteForm">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <bc-autocomplete
                                        v-model="new_status_id"
                                        :label="`${$t('lang.status')} *`"
                                        :items="work_order_status_options"
                                        item-value="status_id"
                                        item-text="status"
                                        hide-selected
                                        :rules="ifValid('work_orders.status_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="(update_work_order_status_dialog = false), (new_status_id = null)">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="updateWorkOrderStatus()">{{ $t("lang.update") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <bc-dialog :value="receive_dialog" max-width="800">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.receive_device") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="receive_dialog"
                        :dialog-status="receive_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text class="pb-5">
                    <v-form ref="quoteForm">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <p>
                                        In order to receive this device please re-enter the Work Order Number: {{ `${work_order.id}-${work_order.public_id}` }}
                                    </p>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field v-model="receive_device_validation" :label="$t('lang.wo_number')" @keydown.enter.prevent></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="(receive_dialog = false), (receive_device_validation = null)">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="receiveWorkOrderDevice()">{{ $t("lang.save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <bc-dialog :value="request_info_dialog" max-width="1100">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.edit_work_order") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="request_info_dialog"
                        :dialog-status="request_info_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text class="pb-5">
                    <v-form ref="work_order">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <bc-autocomplete
                                        v-model="work_order.device_id"
                                        :label="`${$t('lang.device_number')} *`"
                                        :items="devices"
                                        item-value="device_id"
                                        item-text="public_id"
                                        :rules="ifValid('work_orders.device_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        v-model="work_order.contact_name"
                                        :label="`${$t('lang.contact_name')}`"
                                        :counter="showCounter(work_order.contact_name, 'work_order.contact_name')"
                                        :rules="ifValid('work_orders.contact_name')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <bc-phone-input
                                        v-model="work_order.contact_phone"
                                        :phone_number="work_order.contact_phone"
                                        :code="work_order.country_iso_2"
                                        ref="phoneInput"
                                        input-name="contact_phone"
                                        input-label="contact_phone"
                                        :update-object="work_order"
                                        :rules="ifValid('work_orders.contact_phone')"
                                        :isRequired="false"
                                    ></bc-phone-input>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        v-model="work_order.contact_email"
                                        :label="`${$t('lang.contact_email')}`"
                                        :counter="showCounter(work_order.contact_email, 'work_order.contact_email')"
                                        :rules="ifValid('work_orders.contact_email')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-textarea
                                        v-model="work_order.return_address"
                                        :label="`${$t('lang.return_address')}`"
                                        auto-grow
                                        rows="1"
                                        :rules="ifValid('work_orders.return_address')"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        v-model="work_order.inbound_tracking_number"
                                        :label="$t('lang.inbound_tracking_number')"
                                        :counter="showCounter(work_order.inbound_tracking_number, 'work_order.inbound_tracking_number')"
                                        :rules="ifValid('work_orders.inbound_tracking_number')"
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <bc-select
                                        v-model="work_order.warranty_repair"
                                        :label="`${$t('lang.warranty_repair')}`"
                                        :items="yes_no"
                                        item-value="value"
                                        item-text="text"
                                        :rules="ifValid('work_orders.warranty_repair')"
                                    ></bc-select>
                                </v-flex>
                                <v-flex xs12>
                                    <v-textarea
                                        v-model="work_order.reason_for_return"
                                        :label="`${$t('lang.reason_for_return')}`"
                                        auto-grow
                                        rows="1"
                                        :rules="ifValid('work_orders.reason_for_return')"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="request_info_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="saveWorkOrders">{{ $t("lang.save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <bc-modal-print ref="print" @close-method="(file_name = null), $refs.print.close()" :file-name="file_name" :no-button="true"></bc-modal-print>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import Vue from "vue";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            work_order: {},
            file_name: "",
            requote_estimate: {
                zoho_estimate_id: null,
            },
            requote_dialog: false,
            dbGetWorkOrder: _.debounce(this.getWorkOrder, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
            update_work_order_status_dialog: false,
            work_order_status_options: [],
            new_status_id: null,
            receive_dialog: false,
            receive_device_validation: null,
            request_info_dialog: false,
            yes_no: [
                { value: "2", text: this.$t("lang.yes") },
                { value: "1", text: this.$t("lang.no") },
            ],
            inbound_tracking: null,
            outbound_tracking: null,
            tracking_link: "",
            inbound_packages: [],
            outbound_packages: [],
            inbound_loading: false,
            outbound_loading: false,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchWorkOrder", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.work_order) {
                        this.work_order = this.assignObj2(data.work_order, this.rules_work_orders);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=work_order_status&sort_by=2",
                            method: "get",
                            stateProperty: "work_order_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "work_orders", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchWorkOrder", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.work_order) {
                        next((vm) => {
                            vm.work_order = vm.assignObj2(data.work_order, vm.rules_work_orders);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=work_order_status&sort_by=2",
                                method: "get",
                                stateProperty: "work_order_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "work_orders", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=work_order_status&sort_by=2",
            method: "get",
            stateProperty: "work_order_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_work_orders: (state) => state.work_orders.rules_work_orders,
            // work_order_status_options: (state) => state.settings.work_order_status_options,
            work_orders: (state) => state.work_orders.work_orders,
            selectedWorkOrder: (state) => state.work_orders.selectedWorkOrder,
            devices: (state) => state.devices.device_options,
            people: (state) => state.people.person_options,
            estimates: (state) => state.zoho.estimates,
            shipping_carriers: (state) => state.shipping_carriers.shipping_carrier_options,
        }),
        estimatesAdjusted() {
            let adjusted = this.estimates ? this.estimates.filter((e) => e.estimate_id != this.work_order.zoho_estimate_id) : [];
            return adjusted;
        },
        selectedEstimate() {
            let selected = this.requote_estimate.zoho_estimate_id
                ? this.estimates.filter((e) => e.estimate_id == this.requote_estimate.zoho_estimate_id)[0]
                : null;
            return selected;
        },
    },
    methods: {
        ...mapActions([
            "fetchWorkOrder",
            "saveWorkOrder",
            "deleteWorkOrder",
            "printWorkOrder",
            "fetchIotDevices",
            "fetchPeople",
            "fetchShippingCarriers",
            "fetchStatus",
            "fetchDevices",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getWorkOrder(pg_refresh = false) {
            this.startLoader();

            this.fetchWorkOrder({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.work_order) {
                    this.work_order = this.assignObj2(data.work_order, this.rules_work_orders);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.$refs.print.openDialog();

            this.printWorkOrder({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.work_order) {
                    this.file_name = data.work_order.file_name;
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveWorkOrders() {
            this.$store.commit("validationOn");
            this.$nextTick(() => {
                if (this.validateForm("work_order")) {
                    let body = this.prepForm(this.work_order, this.rules_work_orders);

                    this.saveWorkOrder({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.work_order) {
                            this.request_info_dialog = false;
                        } else {
                        }
                    });
                }
            });
        },
        updateWorkPerformed() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("workPerformedForm")) {
                    let body = this.prepForm(this.work_order, this.rules_work_orders);

                    this.saveWorkOrder({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.work_order) {
                            this.refresh(true);
                        } else {
                        }
                    });
                }
            });
        },
        updateWorkOrderStatus() {
            this.$store.commit("validationOn");
            if (this.new_status_id) {
                let body = { id: `${this.$route.params.id}`, status_id: this.new_status_id };

                this.saveWorkOrder({
                    body: body,
                }).then((data) => {
                    if (typeof data != "undefined" && data.work_order) {
                        this.work_order = this.assignObj2(data.work_order, this.rules_work_orders);
                        this.update_work_order_status_dialog = false;
                        this.$store.commit("validationOff");
                    }
                });
            }
        },
        updateQuote() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("quoteForm")) {
                    let body = this.requote_estimate;
                    body["device_id"] = this.work_order.device_id;
                    body["id"] = this.work_order.id;

                    this.saveWorkOrder({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.work_order) {
                            this.requote_dialog = false;
                            this.refresh(true);
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveWorkOrders({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.work_order) {
                    this.work_order = this.assignObj2(data.work_order, this.rules_work_orders);
                }
            });
        },
        deleteWorkOrders() {
            this.deleteWorkOrder({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                console.log(data);
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "work_orders" });
                }
                this.toggleModalLoader(false);
            });
        },
        requote() {
            this.$store.commit("validationOff");
            this.requote_dialog = true;
            this.requote_estimate = {
                zoho_estimate_id: null,
            };
        },
        receiveWorkOrderDevice() {
            if (this.receive_device_validation != `${this.work_order.id}-${this.work_order.public_id}`) {
                Vue.notify({
                    group: "loggedIn",
                    type: "error",
                    text: "The Work Order Number you entered is incorrect. Please try again.",
                });
            } else {
                let body = {
                    date_received: new Date().toISOString().slice(0, 10),
                    device_id: this.work_order.device_id,
                    id: this.work_order.id,
                    status_id: "2",
                };

                this.saveWorkOrder({
                    body: body,
                }).then((data) => {
                    if (typeof data != "undefined" && data.work_order) {
                        this.receive_dialog = false;
                        this.refresh(true);
                    } else {
                    }
                });
            }
        },
        openCompanyModal() {
            // this.assignObj(this.work_order, this.profile, this.rules_work_order);
            // this.work_order.status_id = this.profile.status ? this.profile.status.status_id : null;
            this.request_info_dialog = true;
            // if (dialog == "request_info_dialog") {
            //     this.$nextTick(() => {
            //         this.$refs.phoneInput.updateCurrentPhone({
            //             phone_number: this.profile.contact_phone,
            //             code: this.profile.country_iso_2,
            //         });
            //     });
            // }
        },
        trackParcel() {
            window.open(this.work_order.outbound_tracking_url);
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchWorkOrder({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.work_order) {
                        this.work_order = this.assignObj2(data.work_order, this.rules_work_orders);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader();
                    }
                });
            } else {
                this.finishLoader();
            }

            // if (this.iot_devices.length == 0 || force == true) await this.fetchIotDevices({ body: { options: 1 } });
            if (!this.estimates || force == true) {
                if (this.work_order.company_id) {
                    await this.$store.dispatch("fetchZoho", {
                        url: "customers/" + this.work_order.company_id + "/estimates",
                        method: "get",
                        commit: true,
                        stateProperty: "estimates",
                    });
                } else {
                    await this.$store.commit("mutateZoho", {
                        property: "estimates",
                        with: [],
                    });
                }
            }

            if (this.people.length == 0 || force == true) await this.fetchPeople({ body: { options: 1, login_type: 2 } });

            if (this.devices.length == 0 || force == true) {
                await this.fetchDevices({ body: { options: 1 } });
            }

            if (this.shipping_carriers.length == 0 || force == true) await this.fetchShippingCarriers({ body: { options: 1 } });
            if (this.work_order_status_options.length == 0 || force == true) {
                await this.$store
                    .dispatch("fetchStatus", {
                        url: "status",
                        body: { module: "work_orders" },
                    })
                    .then((data) => {
                        this.work_order_status_options = data.status;
                    });
            }
        },
    },
    mounted() {
        this.refresh();
    },
    created() {},
};
</script>
